<template>
  <div>
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label">
      <b-field
        :label="label"
        :type="{ 'is-danger': errors.length > 0 }"
        :message="errors[0]"
      >
        <input v-show="false" v-model="image" />
      </b-field>
      <p v-if="!image">No image uploaded.</p>
      <img v-if="image" :src="image" />
      <br />
      <b-button v-if="image" size="is-small" @click="removeImage()"
        >Remove</b-button
      >
      <b-button
        size="is-small"
        @click="
          showUpload = !showUpload
          showUrlUpload = false
        "
        >{{ showUpload ? 'Hide Upload' : 'From File' }}</b-button
      >
      <b-button
        size="is-small"
        @click="
          showUrlUpload = !showUrlUpload
          showUpload = false
        "
        >{{ showUrlUpload ? 'Hide Upload' : 'From URL' }}</b-button
      >
    </ValidationProvider>
    <div v-if="showUrlUpload">
      <b-field label="Image URL">
        <b-input v-model="uploadUrl" type="url" />
      </b-field>
      <b-button
        :loading="uploadFromUrlLoading"
        @click="uploadFromUrl(uploadUrl)"
        >Upload from URL</b-button
      >
    </div>
    <b-upload
      v-if="showUpload"
      v-model="imageFile"
      accept="image/*"
      drag-drop
      :loading="showUploadLoading"
      @input="uploadImage"
    >
      <section class="section">
        <div class="content has-text-centered">
          <p>
            <b-icon icon="upload" size="is-large"> </b-icon>
          </p>
          <p>
            Drop your file here or click to upload
          </p>
        </div>
      </section>
    </b-upload>
    <b-progress
      v-if="showUploadLoading"
      type="is-info"
      :value="showUploadProgress"
    ></b-progress>
  </div>
</template>

<script>
import UploadApi from '@/api/upload'
import EventBus from '@/eventbus'

export default {
  name: 'UploadImage',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showUpload: false,
      showUrlUpload: false,
      showUploadLoading: false,
      uploadUrl: null,
      uploadFromUrlLoading: false,
      imageFile: null,
      showUploadProgress: 0,
      image: null
    }
  },
  watch: {
    value(value) {
      this.image = value
    }
  },
  mounted() {
    if (this.value) {
      this.image = this.value
    } else {
      this.$emit('input', null)
    }
  },
  methods: {
    removeImage() {
      this.image = null
      this.$emit('input', null)
    },
    uploadFromUrl(url) {
      this.uploadFromUrlLoading = true
      let filename = url.split('/').pop()
      UploadApi.uploadFromUrl(url, filename)
        .then(response => {
          this.image = response.url
          this.$emit('input', this.image)
          this.showUrlUpload = false
          this.uploadFromUrlLoading = false
        })
        .catch(err => {
          console.log(err)
          this.uploadFromUrlLoading = false
          this.$buefy.toast.open({
            message: `Error uploading from URL`,
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    uploadImage(file) {
      this.showUploadLoading = true
      UploadApi.getPresignedLink({ file: file.name, bucket: 'images' })
        .then(response => {
          EventBus.$on(file.name, progress => {
            this.showUploadProgress = progress
          })
          UploadApi.uploadToS3(response, file)
            .then(() => {
              this.image = response.final
              this.$emit('input', this.image)
              this.showUpload = false
              this.showUploadLoading = false
              EventBus.$off(file.name)
            })
            .catch(err => {
              console.log(err)
              this.$buefy.toast.open({
                message: `Error uploading ${this.label} (2)`,
                position: 'is-top',
                type: 'is-danger'
              })
              this.showUploadLoading = false
            })
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: `Error uploading ${this.label} (1)`,
            position: 'is-top',
            type: 'is-danger'
          })
          this.showUploadLoading = false
        })
    }
  }
}
</script>
